import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  log(log: any): void {
    if (!window['__AnPlatformConfiguration__'].production) {
      /* eslint-disable no-console */
      console.log(log);
    }
  }

  error(err: Error): void {
    if (!window['__AnPlatformConfiguration__'].production) {
      /* eslint-disable no-console */
      console.error(err);
    }
  }
}
